import React, { useContext, useState } from "react"
import { TextField } from "formik-material-ui"
import { Field, Form, Formik } from "formik"

import { Grid, Button, InputAdornment, Hidden } from "@material-ui/core"
import { Tooltip } from "@material-ui/core"
import PrintIcon from "@material-ui/icons/Print"
import Autocomplete from "@material-ui/lab/Autocomplete"
import TextFieldMaterial from "@material-ui/core/TextField"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"

import useStyles from "./styles"
import CostsAndExpenses from "./Modals"
import Loader from "Components/UI/Atoms/Loader"
import { EditContext } from "Components/Hooks/ContextEdit"
import { FormContext } from "Components/Hooks/ContextForm"
import { interfaces } from "service/interfaces"
import { printPDF } from "Helpers"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { AttachMoney } from "@material-ui/icons"

const Quotation = (props) => {
  const classes = useStyles()

  const createDismissableSnackbar = useCustomSnackbar()

  const [wait, setWait] = useState(false)

  const [edit] = useContext(EditContext)

  const { formEdit, setFormEdit, setFormApi, formApi, initialData } =
    useContext(FormContext)

  const getFactor = (name) => {
    const iva = 0.21
    const percepciones = formEdit.vehicle.cia_seguros.percepciones

    const totalPerc = percepciones.reduce(
      (acc, p) => acc + (Number(p.value) || 0) / 100,
      0
    )

    return 1 + iva + totalPerc
  }

  const calcularPorcentajeCotizado = (restos, infoAuto) => {
    const conIVA = parseFloat(restos)
    const valorInfoAuto = parseFloat(infoAuto)

    if (
      !isNaN(conIVA) &&
      !isNaN(valorInfoAuto) &&
      valorInfoAuto > 0
    ) {
      const porcentaje = (conIVA / valorInfoAuto) * 100
      return porcentaje.toFixed(2)
    }

    return ""
  }

  const DATA_FORM = formEdit.hasOwnProperty("vehicle")
    ? {
        ...formEdit.vehicle.vehiculo_cotizacion,

        cotizacion_siniestro: formEdit.vehicle.vehiculo_cotizacion?.cotizacion_restos
          ? (
              parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_restos) /
              getFactor("cotizacion_restos")
            ).toFixed(2)
          : "",

        cotizacion_retiro_neto: formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro
          ? (
              parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_retiro) /
              1.21
            ).toFixed(2)
          : "",

        cotizacion_retiro: !formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro &&
          formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro_neto
          ? (
              parseFloat(formEdit.vehicle.vehiculo_cotizacion.cotizacion_retiro_neto) *
              1.21
            ).toFixed(2)
          : formEdit.vehicle.vehiculo_cotizacion?.cotizacion_retiro || "",

        porcentaje_cotizado_valor_infoAuto: formEdit.vehicle.vehiculo_cotizacion?.porcentaje_cotizado_valor_infoAuto
          ? parseFloat(formEdit.vehicle.vehiculo_cotizacion.porcentaje_cotizado_valor_infoAuto).toFixed(2)
          : formEdit.vehicle.vehiculo_cotizacion?.cotizacion_restos && formEdit.vehicle.vehiculo_cotizacion?.valor_infoauto_adjudicar
            ? calcularPorcentajeCotizado(
                formEdit.vehicle.vehiculo_cotizacion.cotizacion_restos,
                formEdit.vehicle.vehiculo_cotizacion.valor_infoauto_adjudicar
              )
            : ""
      }
    : {}

  const [form, setForm] = useState(DATA_FORM)

  // const formatOneDecimal = (value) => {
  //   if (value === null || value === "" || isNaN(value)) return ""
  //   const num = parseFloat(value)
  //   return num.toFixed(1)
  // }

  const formatForDisplay = (value) => {
    if (value === null || value === "" || isNaN(value)) return ""
    const num = parseFloat(value)
    const rounded = Math.round(num * 100) / 100
    return Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    let newForm = { ...form }
    const factor = getFactor(name)

    if (name === "cotizacion_restos") {
      if (value === "" || value == null) {
        newForm.cotizacion_restos = ""
        newForm.cotizacion_siniestro = ""
        newForm.porcentaje_cotizado_valor_infoAuto = ""
      } else {
        const conIVA = parseFloat(value)
        const neto = conIVA / factor
        newForm.cotizacion_restos = value
        newForm.cotizacion_siniestro = formatForDisplay(neto)

        newForm.porcentaje_cotizado_valor_infoAuto =
          calcularPorcentajeCotizado(
            value,
            newForm.valor_infoauto_adjudicar
          )
      }
    } else if (name === "cotizacion_siniestro") {
      if (value === "" || value == null) {
        newForm.cotizacion_siniestro = ""
        newForm.cotizacion_restos = ""
      } else {
        const neto = parseFloat(value)
        const conIVA = neto * factor
        newForm.cotizacion_siniestro = value
        newForm.cotizacion_restos = formatForDisplay(conIVA)
      }
    } else if (name === "cotizacion_retiro") {
      if (value === "" || value == null) {
        newForm.cotizacion_retiro = ""
        newForm.cotizacion_retiro_neto = ""
      } else {
        const conIVA = parseFloat(value)
        const neto = conIVA / 1.21
        newForm.cotizacion_retiro = value
        newForm.cotizacion_retiro_neto = formatForDisplay(neto)
      }
    } else if (name === "cotizacion_retiro_neto") {
      if (value === "" || value == null) {
        newForm.cotizacion_retiro_neto = ""
        newForm.cotizacion_retiro = ""
      } else {
        const neto = parseFloat(value)
        const conIVA = neto * 1.21
        newForm.cotizacion_retiro_neto = value
        newForm.cotizacion_retiro = formatForDisplay(conIVA)
      }
    } else {
      newForm[name] = value
    }

    // =============================

    if (name === "valor_infoauto_adjudicar") {
      const porcentaje = Number(newForm.porcentaje_min_aseguradora)
      if (value && value !== "" && !isNaN(value) && Number(value) !== 0) {
        const valorInfoAuto = Number(value)
        const resultado = (valorInfoAuto * porcentaje) / 100
        newForm.valor_min_aseguradora = formatForDisplay(resultado)
      } else {
        newForm.valor_min_aseguradora = ""
      }

      newForm.porcentaje_cotizado_valor_infoAuto =
        calcularPorcentajeCotizado(
          newForm.cotizacion_restos,
          value
        )
    }


    setForm(newForm)

    const { cotizacion_siniestro, cotizacion_retiro_neto, porcentaje_cotizado_valor_infoAuto, ...formForBackend } = newForm

    setFormEdit({
      ...formEdit,
      vehicle: {
        ...formEdit.vehicle,
        vehiculo_cotizacion: {
          ...formForBackend,
        },
      },
    })

    setFormApi({
      ...formApi,
      vehiculo_cotizacion: {
        ...formForBackend,
      },
    })
  }

  const handleBlur = (e) => {
    const { name, value } = e.target

    if (name === "observaciones") {
      setForm((prev) => ({
        ...prev,
        [name]: value, 
      }))
      return
    }

    if (!value) return

    let newForm = { ...form }
    const num = parseFloat(value) || 0
    const rounded = Math.round(num * 100) / 100
    newForm[name] = Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2)
    setForm(newForm)
  }

  async function print() {
    setWait(true)
    await interfaces.vehicleInterface
      .vehicleOffer(formEdit.vehicle.id)
      .then((res) => printPDF(res, 1000, 700))
      .catch((error) => {
        createDismissableSnackbar("Algo salió mal!", {
          variant: "error",
        })
      })
    setWait(false)
  }

  const displayValue = (value) => {
    return value === "0.00" || value === null ? "" : value
  }

  const disabledField = () => {
    if (initialData.header.authorization === 1 && edit) {
      return true
    }
    if (initialData.header.authorization === 1 && !edit) {
      return true
    } else return edit ? false : true
  }

  const objeto = [
    {
      id: 1,
      label: "Cotización restos (imp. incluidos)",
      name: "cotizacion_restos",
      sm: 4,
      xs: 12,
      value: displayValue(form.cotizacion_restos),
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 2,
      label: "Porcentaje cotizado según valor InfoAuto",
      name: "porcentaje_cotizado_valor_infoAuto",
      sm: 4,
      xs: 12,
      value: displayValue(form.porcentaje_cotizado_valor_infoAuto),
      select: false,
      disabled: true,
      inputProps: {
        endAdornment: (
          <InputAdornment position="end">
            %
          </InputAdornment>
        ),
      },
    },
    {
      id: 3,
      label: "Cotización restos (neto)",
      name: "cotizacion_siniestro",
      sm: 4,
      xs: 12,
      value: form.cotizacion_siniestro ?? "",
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 4,
      label: "Cotización retiro (IVA incluido)",
      name: "cotizacion_retiro",
      sm: 6,
      xs: 12,
      value: displayValue(form.cotizacion_retiro),
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 5,
      label: "Cotización retiro (neto)",
      name: "cotizacion_retiro_neto",
      sm: 6,
      xs: 12,
      value: form.cotizacion_retiro_neto || "",
      select: false,
      disabled: disabledField(),
      icon: <AttachMoneyIcon />,
    },
    {
      id: 6,
      label: "Estado",
      name: "cotizacion_retiro",
      sm: 12,
      xs: 12,
      value: form.estado_retiro,
      disabled: true,
      icon: <AttachMoneyIcon />,
      select: true,
      options: [
        {
          id: 1,
          label: "Retiro pendiente",
        },
        {
          id: 2,
          label: "Retiro en curso",
        },
        {
          id: 3,
          label: "Retiro realizado",
        },
      ],
    },
    {
      id: 7,
      label: "Observaciones",
      name: "observaciones",
      sm: 12,
      xs: 12,
      value: form.observaciones,
      disabled: disabledField(),
      multiline: true,
      rows: 5,
    },
  ]

  return (
    <div className={classes.rootGrid}>
      <Formik initialValues={form} enableReinitialize>
        {({ values }) => (
          <Form> 
            <Grid
              container
              spacing={2}
              justify="center"
              alignItems="center"
              className={classes.paddingGrids}
            >
              <Grid container item spacing={2} xs={12} className={classes.contentInfoAuto}>
                  <Grid item xs={12} sm={3}>
                    <Field
                      component={TextField}
                      name="valor_infoauto_adjudicar"
                      label="Valor InfoAuto al adjudicar"
                      variant="standard"
                      fullWidth
                      disabled={!edit}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoney fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                      handleChange(e)
                    }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <Field
                        component={TextField}
                        name="valor_infoauto_actual"
                        label="Valor InfoAuto actual"
                        variant="standard"
                        fullWidth
                        disabled={true}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AttachMoney 
                                fontSize="small" 
                                // style={{ color: "#2e497d" }} 
                              />
                            </InputAdornment>
                          ),
                        }}
                        // InputLabelProps={{
                        //   style: { color: "#2e497d" }, 
                        // }}
                      />
                    </Grid>
                
                    <Grid item xs={12} sm={3}>
                      <Field
                        component={TextField}
                        name="valor_min_aseguradora"
                        label="Valor min. solicita aseguradora"
                        variant="standard"
                        fullWidth
                        disabled={true}
                        size="small"
                        value={form.valor_min_aseguradora ?? ""}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AttachMoney 
                                fontSize="small" 
                                // style={{ color: "#2e497d" }} 
                              />
                            </InputAdornment>
                          ),
                        }}
                        // InputLabelProps={{
                        //   style: { color: "#2e497d" }, 
                        // }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <Field
                        component={TextField}
                        name="porcentaje_min_aseguradora"
                        label="Porcentaje min. solicita aseguradora"
                        variant="standard"
                        fullWidth
                        disabled={true}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              %
                            </InputAdornment>
                          ),
                        }}
                        // InputLabelProps={{
                        //   style: { color: "#2e497d" }, 
                        // }}
                      />
                </Grid>
              </Grid>

              {objeto.map((item) => (
                <Grid item sm={item.sm} xs={item.xs} key={item.id}>
                  {item.select ? (
                    <Autocomplete
                      disabled={item.disabled}
                      noOptionsText={"No se encontraron resultados"}
                      getOptionLabel={(option) => option.label}
                      options={item.options}
                      defaultValue={item.options.find(
                        (status) => status.id === parseInt(form.estado_retiro)
                      )}
                      renderInput={(params) => (
                        <TextFieldMaterial
                          {...params}
                          fullWidth
                          label={item.label}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  ) : (
                    <Field
                      component={TextField}
                      disabled={item.disabled}
                      fullWidth
                      variant="outlined"
                      type={item.type}
                      name={item.name}
                      label={item.label}
                      multiline={item.multiline}
                      rows={item.rows}
                      value={item.uppercase ? item.value.toUpperCase() : item.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        ...(item.icon && {
                          startAdornment: (
                            <InputAdornment position="start">
                              {item.icon}
                            </InputAdornment>
                          ),
                        }),
                        ...item.inputProps,
                      }}
                    />
                  )}
                </Grid>
              ))}

              <Grid container justify="flex-end" item xs={12} sm={12} spacing={1}>
                <Tooltip title={"Debe guardar los cambios antes de presionar este botón"}>
                  <Hidden xsDown>
                    <Button
                      className={classes.styleButtons}
                      variant="contained"
                      endIcon={<PrintIcon />}
                      disabled={disabledField()}
                      onClick={print}
                    >
                      IMPRIMIR
                    </Button>
                  </Hidden>
                </Tooltip>
                <CostsAndExpenses disabled={disabledField()} />
              </Grid>
            </Grid>
          </Form> 
        )} 
      </Formik> 
      {wait ? <Loader /> : null}
    </div>
  )
}
export default Quotation
